export const dates = {
  methods: {
    dateTimestamp: date => new Date(date).getTime(),

    stripHour: date => date.split(' ').slice(0, 1).join(' '),

    dateFormat: receiveDate => {
      const date = new Date(receiveDate)
      const dateString = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().split('T')[0]

      return dateString
    },

    diffDate: initialDate => {
      const inicio = new Date(initialDate)
      const now = new Date(Date.now())
      const diff = inicio - now

      return diff > 0
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/dates.js